__turbopack_context__.v({
  "email": "LDL5jq_email",
  "link": "LDL5jq_link",
  "secondary": "LDL5jq_secondary",
  "text": "LDL5jq_text",
});
